import { Link } from "react-router-dom";
import Layout, { PageHeader } from "../components/Layout";
import SEO from "../components/SEO";

function LegalBody({ sections }) {
  return (
    <section className="max-w-3xl mx-auto px-5 md:px-8 py-16 md:py-24">
      <div className="mb-10 font-mono-ez text-xs uppercase tracking-widest text-ez-text/50">
        Placeholder legal copy — final wording to be provided by counsel.
      </div>
      <div className="space-y-10">
        {sections.map((s, i) => (
          <div key={i}>
            <h2 className="font-display text-2xl uppercase tracking-tight mb-3">{i + 1}. {s.t}</h2>
            <p className="text-ez-text/75 leading-relaxed">{s.d}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export function Privacy() {
  return (
    <Layout>
      <SEO title="Privacy Policy" description="How Eazymuv collects, uses and protects your information." />
      <PageHeader eyebrow="Legal" title="Privacy Policy" />
      <LegalBody sections={[
        { t: "Information we collect", d: "We collect information you provide through enquiry and application forms, including your name, email, company and message. [Placeholder]" },
        { t: "How we use it", d: "We use your information solely to respond to your enquiry, evaluate applications, and communicate about our services. [Placeholder]" },
        { t: "Storage & notifications", d: "Form submissions are stored securely in our database and trigger an internal email notification to our operations team." },
        { t: "Data sharing", d: "We do not sell your data. We share it only with service providers necessary to operate the site. [Placeholder]" },
        { t: "Your rights", d: "You may request access to or deletion of your data by contacting us. [Placeholder]" },
      ]} />
    </Layout>
  );
}

export function Terms() {
  return (
    <Layout>
      <SEO title="Terms of Use" description="Terms governing your use of the Eazymuv website." />
      <PageHeader eyebrow="Legal" title="Terms of Use" />
      <LegalBody sections={[
        { t: "Acceptance", d: "By using this website you agree to these terms. [Placeholder]" },
        { t: "Use of the site", d: "The content is provided for informational purposes about Eazymuv and its products. [Placeholder]" },
        { t: "Intellectual property", d: "Eazymuv, Eazymuv OS (EazyOS) and EazyMS marks and content are the property of Eazymuv Technologies Pvt Ltd." },
        { t: "No warranties", d: "Content is provided 'as is' without warranties. Metrics and claims are published only when verified. [Placeholder]" },
        { t: "Contact", d: "Questions about these terms can be directed to our team via the Contact page." },
      ]} />
    </Layout>
  );
}

export function NotFound() {
  return (
    <Layout>
      <SEO title="404 — Not Found" description="Page not found." />
      <section className="min-h-[60vh] flex flex-col items-center justify-center text-center px-5 grid-bg">
        <div className="font-display text-[22vw] md:text-[16vw] leading-none tracking-tighter text-ez-yellow" style={{ WebkitTextStroke: "2px #0A0A0A" }}>404</div>
        <h1 className="font-display text-3xl uppercase tracking-tight mt-4">Off the network</h1>
        <p className="mt-3 text-ez-text/60 max-w-md">This route doesn't exist. Let's get you back to full visibility.</p>
        <Link to="/" data-testid="notfound-home" className="mt-8 inline-flex items-center gap-2 bg-ez-text text-ez-bg px-7 py-4 font-semibold hover:bg-ez-yellow hover:text-ez-text transition-colors">Back to Home</Link>
      </section>
    </Layout>
  );
}
